import { BaseService } from 'core/services';
import OrderingScheduleRouteService from './OrderingScheduleRouteService';

class OrderingScheduleService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new OrderingScheduleRouteService());
    }

    async getUserDaily(options){
        const url = this.routeService.getUserDaily(options);
        return this.apiClient.get(url);
    }

    async generate(resource) {  
        const url = this.routeService.generate(resource);
        return this.apiClient.post(url, resource);
    }

}

export default OrderingScheduleService;
